import { render } from "./EmptyTopic.vue?vue&type=template&id=02818d71&scoped=true"
import script from "./EmptyTopic.vue?vue&type=script&lang=js"
export * from "./EmptyTopic.vue?vue&type=script&lang=js"

import "./EmptyTopic.vue?vue&type=style&index=0&id=02818d71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02818d71"]])

export default __exports__